import { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
export default function useDebouncedState(defaultValue, callbackTime = 5000) {
    const [debouncedValue, setDebouncedValue] = useState(defaultValue);
    const debounced = useDebouncedCallback((value) => {
        setDebouncedValue(value);
    }, callbackTime);
    const setValue = (value) => {
        debounced.callback(value);
    };
    const resetTextField = (value) => {
        setDebouncedValue(value ?? defaultValue);
    };
    return [debouncedValue, setValue, resetTextField];
}
